export default function getParentRecord (activeRecord, recordType, records) {
  const { districts, schools, teachers } = records
  let parentType, lookup
  if (recordType === 'teachers') {
    parentType = 'schools'
    lookup = 'school'
  } else if (recordType === 'schools') {
    parentType = 'districts'
    lookup = 'district'
  } else return {}
  if (!activeRecord) return {}
  const parentRecord = records[parentType][activeRecord[lookup]]
  return parentRecord
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/getParentRecord.js